// extracted by css-extract-rspack-plugin
export default {"root":"root-6p7-2","wrapper":"wrapper-3ln44","interactive":"interactive-3LsgK","selection":"selection-W2FOy"};